import React, { useState, createContext } from 'react';

export const PreviewEditorContext = createContext();

export const PreviewEditorProvider = ({ children }) => {
  const [previewEditorData, setPreviewEditorData] = useState({});
  const [openPreviewEditorDialog, setOpenPreviewEditorDialog] = useState(false);

  const value = {
    previewEditorData,
    openPreviewEditorDialog,
    setPreviewEditorData,
    setOpenPreviewEditorDialog,
  };

  return <PreviewEditorContext.Provider value={value}>{children}</PreviewEditorContext.Provider>;
};
